/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

module.exports = '15.6.1';


//////////////////
// WEBPACK FOOTER
// ./~/react-localization/~/react/lib/ReactVersion.js
// module id = 1145
// module chunks = 1